import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {ProductSummaryModel} from '../../../api/entity/productSummary.model';
import {ProductModel} from '../../../api/entity/product.model';
import {ProductSummaryConverter} from '../../../api/entity/converter/productSummary.converter';
import {ProductDataService} from './productData.service';

@Injectable()
export class ProductSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<ProductSummaryModel,
        ProductSummaryConverter,
        ProductModel> {
    constructor(dataService: ProductDataService, converter: ProductSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ProductModel {
        return new ProductModel();
    }
}
